// extracted by mini-css-extract-plugin
module.exports = {"container":"fun88-virtual-fifa-world-cup-slider_container__dAe46"};